import { LoadScript } from "@react-google-maps/api";
import { Alert, ConfigProvider, Empty, Spin, message, notification } from "antd";
import en_US from "antd/es/locale/en_US";
import { ThemeProvider } from "styled-components";
import { ReactComponent as EmptyIcon } from "./assets/Icons/Empty.svg";
import { theme } from "./assets/theme";
import AuthProvider from "./context/AuthProvider";
import BreadcrumbProvider from "./context/BreadcrumbProvider";
import RemaxConfigProvider from "./context/ConfigProvider";
import IdleHandler from "./IdleHandler";
import RootNavigator from "./navigation/RootNavigator";
// import { MainCheckHealth } from "@qlibs/react-components";
import FingerprintJS from "@fingerprintjs/fingerprintjs";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useEffect } from "react";
import { MainCheckHealth } from "./components/CheckHealth/MainCheckHealth";
import ForceUpdate from "./components/ForceUpdate";
import { httpRequest } from "./helpers/api";
import { useInitPropertyTypes } from "./hooks/usePropertyType";

const queryClient = new QueryClient();

const { ErrorBoundary } = Alert;
function App() {
	useInitPropertyTypes();
	message.config({ getContainer: () => document.getElementById("root")! });
	const [api, contextHolder] = notification.useNotification();

	useEffect(() => {
		// Initialize FingerprintJS and get a visitor ID.
		FingerprintJS.load().then((fp) => {
			fp.get().then((result) => {
				// This is the visitor identifier:
				const visitorId = result.visitorId;
				console.log(visitorId);
				const deviceId = localStorage.getItem("deviceId");
				if (!deviceId) {
					localStorage.setItem("deviceId", visitorId);
				}
			});
		});
	}, []);

	useEffect(() => {
		const handleStorage = async (event: any) => {
			if (event.key === "auth_event") {
				if (event.newValue === "login" || event.newValue === "logout") {
					console.log(event.newValue + " APP");
					window.location.reload();
				}
			}
		};

		window.addEventListener("storage", handleStorage);

		return () => {
			window.removeEventListener("storage", handleStorage);
		};
	}, []);

	return (
		<ErrorBoundary>
			<LoadScript
				libraries={["places"]}
				googleMapsApiKey={process.env.REACT_APP_GOOGLE_API_KEY as string}
				loadingElement={
					<Spin size="large">
						<div style={{ width: "100vw", height: "100vh" }} />
					</Spin>
				}
			>
				{contextHolder}

				<ConfigProvider
					renderEmpty={() => (
						<Empty
							image={<EmptyIcon />}
							description="No Records Found"
						/>
					)}
					locale={en_US}
				>
					<RemaxConfigProvider>
						<ThemeProvider theme={theme}>
							<MainCheckHealth
								url={process.env.REACT_APP_BASE_URL + "/health"}
								axiosInstance={httpRequest as any}
								intervalCheck={60000}
							/>

							<QueryClientProvider client={queryClient}>
								<BreadcrumbProvider>
									<AuthProvider>
										<IdleHandler>
											<RootNavigator />
											<ForceUpdate />
										</IdleHandler>
									</AuthProvider>
								</BreadcrumbProvider>
							</QueryClientProvider>
						</ThemeProvider>
					</RemaxConfigProvider>
				</ConfigProvider>
			</LoadScript>
		</ErrorBoundary>
	);
}

export default App;
